import axios from '../index'

export function generateContentEntity(params) {
  return axios.post('/ajax/users/ai_content/content_entities/custom_generate', params)
}

export function rerun(params) {
  return axios.post(`/ajax/users/ai_content/content_entities/${params.id}/rerun`, params)
}
